import styled from 'styled-components'
import bg_download from 'src/assets/images/bg_download.svg'

export const FooterWrapper = styled.footer`
   width: 100%;
`

/* ================= DOWNLOAD BANNER ================= */

export const DownloadBanner = styled.section`
   margin: 0px auto;
   max-width: 1400px;
   padding: 64px;
   border-radius: 12px;
   background-image: url(${bg_download});
   background-repeat: no-repeat;
   background-size: cover;
   background-position: center;
   overflow: hidden;

   @media (max-width: 1400px) {
      margin-left: 16px;
      margin-right: 16px;
   }

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      padding: 32px 20px;
   }
`

export const BannerContent = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 24px;
   }
`

export const BannerLeft = styled.div`
   max-width: 50%;

   h1 {
      color: #fff;
      margin-bottom: 8px;
      line-height: 1.3;
   }

   span {
      display: block;
      color: #fff;
      opacity: 0.8;
      margin-bottom: 8px;
      line-height: 1.4;
   }

   p {
      opacity: 0.8;
      margin-bottom: 24px;
      line-height: 1.6;
   }

   .store-buttons {
      display: flex;
      gap: 12px;
   }

   .store-buttons img {
      height: 48px;
      width: auto;
      transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);

      &:hover {
         transform: scale(1.08);
      }

      &:active {
         transform: scale(0.95);
      }
   }

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      max-width: 100%;

      h1 {
         font-size: 28px;
      }

      span {
         font-size: 14px;
      }

      p {
         font-size: 14px;
         margin-bottom: 20px;
      }

      .store-buttons {
         justify-content: center;
      }

      .store-buttons img {
         height: 56px;
      }
   }
`

export const BannerRight = styled.div`
   img {
      max-width: 360px;
   }
`

/* ================= QR ================= */

export const QrBox = styled.div`
   background: #181a1f;
   padding: 12px;
   border-radius: 20px;
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-left: 10px;

   @media (max-width: 768px) {
      margin-left: 0;
   }
`

export const QrImg = styled.img`
   width: 240px;
   height: 240px;
   background: #fff;
   padding: 12px;
   border-radius: 16px;

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      width: 220px;
      height: 220px;
   }

   /* ===== Small mobile ===== */
   @media (max-width: 400px) {
      width: 180px;
      height: 180px;
      padding: 8px;
   }
`

export const QrText = styled.div`
   margin-top: 12px;
   color: #fff;
   font-size: 18px;
   font-weight: 700;
   letter-spacing: 2px;

   @media (max-width: 768px) {
      font-size: 16px;
      letter-spacing: 1.5px;
   }
`

/* ================= FOOTER MAIN ================= */

export const FooterMain = styled.div`
   max-width: 1400px;
   margin: 0 auto;
   padding: 64px 24px 32px 24px;
`

export const FooterTop = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   gap: 16px;

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
   }
`

export const FooterBrand = styled.div`
   display: flex;
   align-items: center;
   gap: 16px;
   color: #000;

   span {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 500;
      gap: 6px;
      white-space: nowrap;
   }

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;

      span {
         font-size: 14px;
      }
   }
`

export const FooterSocial = styled.div`
   display: flex;
   align-items: center;
   gap: 16px;
   font-size: 14px;
   color: #000;

   span {
      font-size: 12px;
      font-weight: 500;
      white-space: nowrap;
   }

   img {
      width: 20px;
      height: 20px;
      cursor: pointer;
   }

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      width: 100%;
      justify-content: flex-start;
      gap: 12px;

      span {
         font-size: 14px;
      }
   }
`

export const FooterColumns = styled.div`
   display: grid;
   grid-template-columns: repeat(5, 1fr);
   gap: 32px;
   padding: 24px 0;

   h4 {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 12px;
   }

   a {
      display: block;
      font-size: 12px;
      font-weight: 500;
      color: #181a10;
      margin-bottom: 8px;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
         color: #edbb1d;
      }
   }

   /* ===== Tablet ===== */
   @media (max-width: 1024px) {
      grid-template-columns: repeat(3, 1fr);
   }

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
   }

   /* ===== Small mobile ===== */
   @media (max-width: 480px) {
      grid-template-columns: 1fr;

      h4 {
         margin-top: 12px;
      }
   }
`

/* ================= FOOTER BOTTOM ================= */

export const FooterBottom = styled.div`
   border-top: 1px solid #eee;
`

export const FooterBottomContent = styled.div`
   max-width: 1400px;
   margin: 0 auto;
   padding: 16px;

   display: flex;
   justify-content: space-between;
   align-items: center;
   gap: 16px;

   font-size: 12px;
   color: #000;

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
   }
`

export const FooterLinks = styled.div`
   display: flex;
   gap: 24px;
   font-size: 12px;
   flex-wrap: wrap;

   a {
      color: #000;
      text-decoration: none;
      cursor: pointer;
   }

   /* ===== Mobile ===== */
   @media (max-width: 768px) {
      gap: 12px;
   }
`
